import { Panel } from 'component/Space/Panel'
import { observer } from 'mobx-react-lite'
import { Leg } from 'page/ProfileScreen/Legs/Leg'
import { store } from 'store/store'

type Props = {
  detailed?: boolean
}

function getLegs(detailed: boolean | undefined): number[] {
  const { cfg, heightRange } = store.profile.form
  if (detailed) {
    const { min, max } = cfg.dimensions.legLength
    const items: number[] = []
    for (let item = min; item <= max; ++item) {
      if (item % 2 === 0) items.push(item)
    }
    return items
  } else {
    return cfg.heights_config.find(c => c.height === heightRange)?.legLength ?? []
  }
}

export const Legs = observer(({ detailed }: Props) => {
  const { heightRange } = store.profile.form
  const prefix = detailed ? '' : heightRange + ' '
  const legs = getLegs(detailed)
  const last = legs.length - 1

  return <Panel>
    {legs.map((leg, index) => (
      <Leg key={prefix + leg} value={leg} plus={index === last} />
    ))}
  </Panel>
})
